import GrtLoading from '@/components/GrtLoading/GRTLoading';
import { useEffect } from 'react';

import { oauthCodeLogin } from '@/api/login';
import withRouter from '@/components/withRouter';
import { updateCookie } from '@/utils/index';
import Toast from '@/components/Toast';
const redirect_uri = `${window.location.origin}${window.location.pathname}`,
 BhyzLogin = (props) => {
    let code = props.searchParams.get('code'),
     source = props.searchParams.get('source');
    const thirdLogin = async () => {
        let data = {
            third_code: 'xinwu',
            code: code,
            redirect_uri: redirect_uri
        },
         res = await oauthCodeLogin(data);
        if (res && res.success) {
            updateCookie(Object.assign(res.data, { domain: window.location.host }));
            let { protocol, host } = window.location,
             side = source.toLowerCase() === 'pc' ? 'web' : 'mobile';
            window.location.href = `${protocol}//${host}/${side}`;
        } else {
            Toast.error(res.msg || '登录失败');
        }
    };
    useEffect(() => {
        if (code) {
            thirdLogin();
        }
    }, [code]);
    return (
        <div style={{ height: window.innerHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <GrtLoading></GrtLoading>
        </div>
    );
};

export default withRouter(BhyzLogin);
